import {combineReducers} from 'redux'
import venue from './venue'
import accommodation, * as fromAccommodation from './accommodation'

const App = combineReducers({
  venue,
  accommodation,
})

export default App

export const getAccommodationOptions = state => {
  return fromAccommodation.getFilteredAccommodationOptions(state.accommodation)
}



// WEBPACK FOOTER //
// ./src/reducers/index.js